module.exports = __webpack_public_path__ + "static/ico-maestro-e2f934af0c81a2aea91b241772d100fd.svg";